"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineNumberCSS = exports.default = exports.NumberToolbox = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var NumberToolbox = function NumberToolbox(Survey) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };
  var numberToolbox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var name = numberToolbox.name;
  var widget = _objectSpread(_objectSpread({}, numberToolbox), {}, {
    questionJSON: _objectSpread(_objectSpread({}, numberToolbox.json), {}, {
      internalType: _constants.TOOLBOX_TYPE.NUMBERS
    }),
    widgetIsLoaded: function widgetIsLoaded() {
      return true;
    },
    isFit: function isFit(question) {
      return question.getType() === name;
    },
    init: function init() {
      /* eslint-disable */
      Survey.Serializer.addClass(name, [], null, 'text');
      Survey.Serializer.findProperty(name, 'name').displayName = 'Field ID';
      Survey.Serializer.findProperty(name, 'name').isRequired = true;
      Survey.Serializer.findProperty(name, 'title').displayName = 'Field Name';
      Survey.Serializer.findProperty(name, 'description').maxLength = 160;
      // Custom properties for min editor
      Survey.Serializer.findProperty(name, 'min').type = 'minMaxCustom';
      Survey.Serializer.findProperty(name, 'min').dependedProperties = ['max'];
      Survey.Serializer.findProperty(name, 'min').isCustom = true;
      Survey.Serializer.findProperty(name, 'min').displayName = t('Min');
      // Custom properties for max editor
      Survey.Serializer.findProperty(name, 'max').type = 'minMaxCustom';
      Survey.Serializer.findProperty(name, 'max').dependedProperties = ['min'];
      Survey.Serializer.findProperty(name, 'max').isCustom = true;
      Survey.Serializer.findProperty(name, 'max').displayName = t('Max');
      /* eslint-enable */
    },

    isDefaultRender: true
  });
  Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, name);
};
exports.NumberToolbox = NumberToolbox;
var _default = NumberToolbox;
exports.default = _default;
var defineNumberCSS = function defineNumberCSS(survey) {
  survey.onUpdateQuestionCssClasses.add(function (_, options) {
    var classes = options.cssClasses;
    if (options.question.getType() === _constants.MODEL_QUESTIONS.NUMBER) {
      classes.title = "".concat(classes.title, " number-toolbox-title");
    }
  });
};
exports.defineNumberCSS = defineNumberCSS;